export const headTableCells = [
  { id: 1, property: '', label: '', width: '5%', hideOnMobile: false },
  { id: 2, property: 'Title', label: 'Title', width: '30%', hideOnMobile: false },
  { id: 3, property: 'CreatedByUser', label: 'Created By', width: '20%', hideOnMobile: true },
  { id: 4, property: 'CreatedDate', label: 'Created Date', width: '15%', hideOnMobile: true },
  { id: 5, property: 'ExpireDate', label: 'Expire Date', width: '15%', hideOnMobile: false },
  { id: 6, property: 'Status', label: 'Status', width: '15%', hideOnMobile: false },
];
